module.exports = __webpack_public_path__ + "static/img/2.e92e35e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/2.png
// module id = 6MUN
// module chunks = 0